import { render } from "./EnTabs.vue?vue&type=template&id=a171ef24&ts=true"
import script from "./EnTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnTabs.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/base/EnTabs/EnTabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a171ef24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a171ef24', __exports__)) {
    api.reload('a171ef24', __exports__)
  }
  
  module.hot.accept("./EnTabs.vue?vue&type=template&id=a171ef24&ts=true", () => {
    api.rerender('a171ef24', render)
  })

}


export default __exports__